<template>
    <div class="container" style="margin-top: 30px;">
        <div class="row" style="margin: 30px 0;">
            <div class="col-md-4 wow fadeInUp class-img-1"  data-wow-delay="0s" data-wow-duration="1000ms">
                <a href="https://iot.sslunion.com/shuangQiangGroup/bigScreen?formUrl=wuming" target="_blank">
                    <div class="hover-image"><img src="~@/assets/images/bigscreen/home.jpg" width="100%"/></div>
                    <div class="name-title">中国无名碳链（指数）平台</div>
                </a>
            </div>
            <div class="col-md-4 wow fadeInUp class-img-1"  data-wow-delay="0s" data-wow-duration="1000ms">
                <a href="https://iot.sslunion.com/bigScreen/HuangGuanJiaRi?formUrl=wuming" target="_blank">
                    <div class="hover-image"><img src="~@/assets/images/bigscreen/huangguan.jpg" width="100%"/></div>
                    <div class="name-title">中国无名碳链（指数）平台-皇冠假日酒店</div>
                </a>
            </div>
            <div class="col-md-4 wow fadeInUp class-img-1"  data-wow-delay="0s" data-wow-duration="1000ms">
                <a href="https://iot.sslunion.com/bigScreen/tianMuHu/S1?formUrl=wuming" target="_blank">
                    <div class="hover-image"><img src="~@/assets/images/bigscreen/tianmuhu.jpg" width="100%"/></div>
                    <div class="name-title">中国无名碳链（指数）平台-天目湖酒店</div>
                </a>
            </div>
            <div class="col-md-4 wow fadeInUp class-img-1"  data-wow-delay="0s" data-wow-duration="1000ms">
                <a href="https://iot.sslunion.com/bigScreen/HuaXiaUniversity?formUrl=wuming" target="_blank">
                    <div class="hover-image"><img src="~@/assets/images/bigscreen/huaxia.jpg" width="100%"/></div>
                    <div class="name-title">中国无名碳链（指数）平台-华夏学院</div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "bigScreenMap",
        data() {
            return {}
        },
        components: {},
        watch: {},
        mounted() {

        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>
    .hover-image{
        cursor: pointer;
        overflow: hidden;
    }
.hover-image img{
    transition: transform 0.5s ease; /* 平滑的变换效果 */
    display: block; /* 使得图片可以设置宽高 */
}
.hover-image:hover img{
    transform: scale(1.1); /* 鼠标略过时放大1.1倍 */
}
    .name-title{
        text-align: center;
        padding: 10px;
        color: #333333;
    }
    .class-img-1{
        margin-bottom: 30px;
    }
</style>
